const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path
        d="M0.28187 6.25527L0.315812 15.8606C0.315811 15.9964 0.349753 16.0982 0.349753 16.234C0.349753 16.3018 0.383694 16.3358 0.383694 16.4037C0.383694 16.4716 0.417636 16.5055 0.451577 16.6073C0.485518 16.6413 0.485517 16.7091 0.5534 16.777C0.587341 16.811 0.587341 16.8788 0.621282 16.9128L0.824929 17.1164C0.892811 17.1843 0.994635 17.2861 1.09646 17.3201C1.1304 17.354 1.19828 17.354 1.23222 17.388C1.26616 17.4219 1.33405 17.4219 1.36799 17.4558C1.40193 17.4898 1.46981 17.4898 1.53769 17.4898C1.63952 17.5916 1.7074 17.5916 1.7074 17.5916C1.80922 17.6255 1.94499 17.6255 2.08075 17.6255L11.6861 17.6595C12.1613 17.6595 12.6025 17.4898 12.9419 17.1504C13.2813 16.811 13.451 16.3697 13.451 15.8946C13.451 15.4194 13.2813 14.9781 12.9419 14.6387C12.6025 14.2993 12.1613 14.1296 11.6861 14.1296L6.39127 14.1296L17.1506 3.37028C17.8294 2.69145 17.8294 1.53746 17.1506 0.858633C16.4718 0.179811 15.3178 0.179811 14.639 0.858634L3.87963 11.618L3.87963 6.32315C3.87963 5.84798 3.70992 5.40674 3.37051 5.06733C3.0311 4.72792 2.58987 4.55822 2.11469 4.55822C1.63952 4.55822 1.19828 4.72792 0.858868 5.06733C0.519456 5.33886 0.28187 5.7801 0.28187 6.25527Z"
      />
    </svg>
  );
}
